//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head() {
    return {
      title: 'Studioars.pl - Career',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'lorem ipsum dolor sit amet',
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: '',
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: '',
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: '',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: '',
        },
      ],
    }
  },
}
